import { customAlphabet } from 'nanoid';
// Using custom alphabet (https://github.com/CyberAP/nanoid-dictionary?tab=readme-ov-file#nolookalikes) to make IDs more readable
export const getRequestId = customAlphabet('346789ABCDEFGHJKLMNPQRTUVWXYabcdefghijkmnpqrtwxyz', 12);
export const requestIdHeader = () => {
    return {
        'X-Request-Id': getRequestId(),
    };
};
//# sourceMappingURL=requestId.js.map